module.exports = __webpack_public_path__ + "img/manual1.c4d3e915.jpg";